import React from "react";
const LocationIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...props}>
    <path
      d="M13 19C14.8 15.4 20.2 13.0765 20.2 8.2C20.2 4.22355 16.9764 1 13 1C9.02355 1 5.8 4.22355 5.8 8.2C5.8 13.0765 11.2 15.4 13 19Z"
      fill="#DED9E9"
    />
    <path
      d="M13 9.4C13.6627 9.4 14.2 8.86274 14.2 8.2C14.2 7.53726 13.6627 7 13 7C12.3373 7 11.8 7.53726 11.8 8.2C11.8 8.86274 12.3373 9.4 13 9.4Z"
      fill="#DED9E9"
    />
    <path
      d="M4.6 15.7436C2.37837 16.7237 1 18.0894 1 19.6C1 22.5823 6.37258 25 13 25C19.6274 25 25 22.5823 25 19.6C25 18.0894 23.6216 16.7237 21.4 15.7436M20.2 8.2C20.2 13.0765 14.8 15.4 13 19C11.2 15.4 5.8 13.0765 5.8 8.2C5.8 4.22355 9.02355 1 13 1C16.9765 1 20.2 4.22355 20.2 8.2ZM14.2 8.2C14.2 8.86274 13.6627 9.4 13 9.4C12.3373 9.4 11.8 8.86274 11.8 8.2C11.8 7.53726 12.3373 7 13 7C13.6627 7 14.2 7.53726 14.2 8.2Z"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default LocationIcon;
